import React, { useEffect, useState } from 'react';
import { isNonEmpty } from '../../utils/arrayUtils';
import Loading from '../../components/base/Loading';
import { Text } from '../../components/base/Text';
import EditableTable from '../../components/base/Table';
import { useDeleteInvoice, useGetInvoices, useUpdateInvoice } from '../../networking/useInvoice';
import { InvoiceState } from './InvoiceState';
export const InvoicesView = () => {
    const [invoices, setInvoices] = useState([]);
    const [colDefs, setColDefs] = useState([]);
    const { isLoading, data, call } = useGetInvoices();
    const { data: dataUpdate, call: callUpdate } = useUpdateInvoice();
    const { data: dataDelete, call: callDelete } = useDeleteInvoice();
    const displayMapping = {
        vendor: 'Vendor',
        total_amount: 'Total amount ($)',
        state: 'State',
    };
    useEffect(() => {
        if (data && isNonEmpty(data.items)) {
            const ordersTrasformed = data.items.map((invoice) => {
                invoice['key'] = invoice.id;
                return invoice;
            });
            const columnFields = Object.keys(displayMapping).map((col, index) => {
                if (col === 'state') {
                    return {
                        dataIndex: col,
                        key: col,
                        title: displayMapping[col],
                        editable: false,
                        render: (text, record) => {
                            return React.createElement(InvoiceState, { text: text, record: record, updateRecord: callUpdate });
                        },
                    };
                }
                return { dataIndex: col, key: col, title: displayMapping[col], editable: true };
            });
            setColDefs(columnFields);
            setInvoices(ordersTrasformed);
        }
    }, [data]);
    useEffect(() => {
        const columnFields = Object.keys(displayMapping).map((col, index) => {
            return { dataIndex: col, key: col, title: displayMapping[col], editable: true };
        });
        setColDefs(columnFields);
        call();
    }, []);
    const onSave = (id, item) => {
        callUpdate({ entity_id: id, fields_to_update: item });
    };
    const onDelete = (id) => {
        callDelete({ entity_id: id });
    };
    return (React.createElement("div", { style: { padding: '1.5vw', overflowY: 'auto', gap: 24 } },
        React.createElement(Text, { value: 'Invoices', className: "header1" }),
        React.createElement("div", { style: { paddingTop: '1vw' } }, isLoading ? (React.createElement(Loading, null)) : isNonEmpty(invoices) ? (React.createElement(EditableTable, { tableData: invoices, tableColumns: colDefs, addEditColumn: true, onSave: onSave, onDelete: onDelete })) : (React.createElement(React.Fragment, null, "No invoices found")))));
};
